// Filter store
import mutations from './mutations';
import actions from './actions';

// Initial state
const state = {
  filters: {},
};

export default {
  actions,
  mutations,
  state,
};
